module.exports = __webpack_public_path__ + "b32ee9e865a886671ad14fc0532577c0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/wizards-hut-empty.png
// module id = 348
// module chunks = 0